module.exports = __webpack_public_path__ + "static/media/lobster-home-2-tiny.8613d0da.jpg";